import { request } from './index.js'
import { oldPlatform } from './config.js';
// 获取用户token
// export async function getUserToken() {
//   return request({
//     method: `post`,
//     url: `${oldPlatform}/login/password`,
//     data: {
//       "phone":"15249230296",
//       "password":"123456"
//     } 
//   })
// }

// 获取审批表单信息
export async function getModelDetails(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approve/model/detailed`,
    data: {
      modelId: params
    }
  })
}

// 提交表单
export async function submitFormData(params, config) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/add`,
    ...config,
    data: { ...params }
  })
}

// 获取审核流程信息

export async function getApplyInfo(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/info`,
    data: { ...params }
  })
}

// 审批通过
export async function handleArgee(params, config) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/action`,
    ...config,
    data: { ...params }
  })
}

// 文件上传
export async function upload(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/res/upload`,
    headers: {
      "Content-Type": "multipart/form-data"
    },
    data: params
  })
}
// 多文件上传
export async function uploadList(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/res/uploadMulti`,
    headers: {
      "Content-Type": "multipart/form-data"
    },
    data: params
  })
}
export async function getApproveAndCopy(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/links`,
    data: { ...params }
  })
}

export async function getAddressBook(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/office/getAddressBook`,
    data: { ...params }
  })
}

export async function getOfficeList(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/office/officeList`,
    data: { ...params }
  })
}

export async function getJobList(id) {
  return request({
    method: `get`,
    url: `${oldPlatform}/post/info/relation/${id}`,
  })
}

export async function searchStaffList(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/office/searchStaffList`,
    data: { ...params }
  })
}

// 获取员工岗位详情
export async function setMainStaff(params) {
  const { companyId } = params
  return request({
    method: `post`,
    url: `${oldPlatform}/staff/post/detail/${companyId}`,
    data: { ...params }
  })
}

export async function getTaskList(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/report/task/getListByDate`,
    data: { ...params }
  })
}

// 写日报
export async function submitTask(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/report/task/add`,
    data: { ...params }
  })
}

// 日报详情
export async function getTaskDetail(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/report/task/detailQuery`,
    data: { ...params }
  })
}

// 日报打分
export async function handleGrade(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/report/task/reportGrade`,
    data: params
  })
}

// 写月报
export async function submitMonthReport(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/report/task/addMonthlyReport`,
    data: params
  })
}

// 月报详情
export async function getMonthReportDetail(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/report/task/monthlyReportQuery`,
    data: { ...params }
  })
}
// 查看上个月计划
export async function getReportPlan(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/report/task/getReportPlan`,
    data: { ...params }
  })
}

// 新增抄表记录
export async function newCopyTable(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/rent/meter/reading/addRentMeterReadingRecord`,
    data: { ...params }
  })
}

// 客户列表
export async function clientList(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/customer/getRentFollowRecordListByPage`,
    data: { ...params }
  })
}

// 查询用户当月薪酬
export async function queryPay(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/salary/record/mySalary`,
    data: { ...params }
  })
}

// 查询薪酬列表
export async function queryPayList(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/salary/record/mySalaryList`,
    data: { ...params }
  })
}

// 签收工资
export async function signFor(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/salary/record/sign`,
    data: { ...params }
  })
}

// 获取当前用户信息
export async function getMineInfo(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/mine/getMineInfo`,
    data: { ...params }
  })
}

// 我的考勤假期规则列表查询
export async function getHoliday(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/attendance/holidayRule/myHoliday`,
    data: { ...params }
  })
}
// 写日报前查看是否已经填写汇报人
export async function getIsApproverSet(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/report/task/isApproverSet/${params}`,
  })
}
//修改日报
export async function updateTask(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/report/task/update`,
    data: { ...params }
  })
}

//计算请假时长
export async function computeTime(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/getTotalLeaveHours`,
    data: { ...params }
  })
}

//计算请假天数
export async function computeTimeV2(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/getTotalLeaveHoursV2`,
    data: { ...params }
  })
}

//计算公出和出差时长
export async function computeTimeV3(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/getTotalBusinessTripLeaveHours`,
    data: { ...params }
  })
}

// 汇报管理模板列表
export async function getReportList(id) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approve/model/report/list/${id}`,
  })
}

// 汇报管理审批列表
export async function getReportApprovalList(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/list`,
    data: { ...params }
  })
}

// 知识库详情
export async function getKnowDeatil(id) {
  return request({
    method: `get`,
    url: `/app/knowledge/info/${id}`,
  })
}

//banner详情
export async function getBannerDetail(id) {
  return request({
    method: `get`,
    url: `${oldPlatform}/app/banner/bannerLinkInfo/${id}`
  })
}

//banner详情
export async function getMakeCardTimes(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/getMakeCardTimes`,
    data: { ...params }
  })
}

// 删除草稿箱
export async function delApproval(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/del`,
    data: { ...params }
  })
}
//获取汇报看板
export async function getPersonalReportBoard(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/report/statistics`,
    data: { ...params }
  })
}

//获取汇报管理下审批分布
export async function getPersonaldistribution(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/report/statistics/distribution`,
    data: { ...params }
  })
}

//获取汇报管理下趋势
export async function getApproveTrend(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/report/statistics/trend`,
    data: { ...params }
  })
}

//获取汇报管理下个人汇报统计
export async function getPersonalReport(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/report/statistics/person`,
    data: { ...params }
  })
}
//获取汇报管理下个人汇报统计
export async function getOrganizationReport(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/report/statistics/company/num`,
    data: { ...params }
  })
}
//获取汇报管理下审批统计公司人数
export async function getCompanyPersonReport(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/report/statistics/company/person`,
    data: { ...params }
  })
}

//获取汇报管理总览列表
export async function getReportOverviewList(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/report/list`,
    data: { ...params }
  })
}

//通过公司id查询可用的汇报管理分组下的审批模板
export async function getRangeOptionsList(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approve/model/report/statistics/list`,
    data: { ...params }
  })
}
//获取汇报管理下审批统计公司/部门提交数人数
export async function getReportPerson(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/report/statistics/company/person/num`,
    data: { ...params }
  })
}

//获取汇报管理下审批统计公司/部门提交数人数
export async function getTrendYear(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/report/statistics/trend/year`,
    data: { ...params }
  })
}
//获取审批展示内容
export async function getApproveInfo(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/info/view`,
    data: { ...params }
  })
}

// 获取汇报管理下审批个人汇报统计列表（按月）
export async function getPersonalAll(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/report/statistics/person/all`,
    data: { ...params }
  })
}
// 获取组织架构
export async function getCompanySystem(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/office/report/getAddressBook`,
    data: { ...params }
  })
}

// 日报统计总览
export async function getOverviewData(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/sysStaffReportStatisticsEntity/getReportStatisticsOverView`,
    data: { ...params }
  })
}

// 日报总览列表览(月)
export async function getReportStatisticsOverViewDetailByMonth(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/sysStaffReportStatisticsEntity/getReportStatisticsOverViewDetailByMonth`,
    data: { ...params }
  })
}

// 日报总览列表览(天)
export async function getReportStatisticsOverViewDetailByDate(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/sysStaffReportStatisticsEntity/getReportStatisticsOverViewDetailByDate`,
    data: { ...params }
  })
}

// 个人日报详情（月）
export async function getListByStaffIdAndMonth(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/sysStaffReportStatisticDetailEntity/getListByStaffIdAndMonth`,
    data: { ...params }
  })
}

// 个人日报详情（天）
export async function getListByStaffIdAndDate(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/sysStaffReportStatisticDetailEntity/getListByStaffIdAndDate`,
    data: { ...params }
  })
}

// 日报统计趋势
export async function getReportStatisticsTrend(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/sysStaffReportStatisticsEntity/getReportStatisticsTrend`,
    data: { ...params }
  })
}

// 日报统计趋势
export async function getReportStatisticsTrendList(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/sysStaffReportStatisticsEntity/getReportStatisticsTrendList`,
    data: { ...params }
  })
}

// 日报统计提交人次
export async function getReportStatisticsSubmitNum(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/sysStaffReportStatisticsEntity/getReportStatisticsSubmitNum`,
    data: { ...params }
  })
}

// 日报统计提交率
export async function getReportStatisticsSubmitRate(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/sysStaffReportStatisticsEntity/getReportStatisticsSubmitRate`,
    data: { ...params }
  })
}
// 日报提交列表
export async function getReportStatisticsSubmitList(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/sysStaffReportStatisticsEntity/getReportStatisticsSubmitList`,
    data: { ...params }
  })
}

// 写日报是否有权限
export async function writeDailyPermission(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/sysStaffReportScopeEntity/hasPermission`,
    data: { ...params }
  })
}

// 判断提交是否要谈提示语
export async function supplementTip(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/report/task/supplement/tip`,
    data: { ...params }
  })
}

// 获取公司列表
export async function getCompanyAddressList(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/office/getCompanyAddressList`,
    data: { ...params }
  })
}

// 获取公司列表
export async function getAddressList(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/office/addressList`,
    data: { ...params }
  })
}

// 模糊查询员工
export async function getClassificationStatistics(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/office/classificationStatistics`,
    data: { ...params }
  })
}

// 日报提交总数按月
export async function getReportStatisticsOverViewNumByMonth(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/sysStaffReportStatisticsEntity/getReportStatisticsOverViewNumByMonth`,
    data: { ...params }
  })
}

// 日报提交总数按日
export async function getReportStatisticsOverViewNumByDate(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/sysStaffReportStatisticsEntity/getReportStatisticsOverViewNumByDate`,
    data: { ...params }
  })
}

// 查询新平台附件
export async function getUrls(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/res/urls`,
    data: params
  })
}

// 拿到oa审批详情
export async function getApprovalInstanceInfo(params) {
  return request({
    method: `post`,
    url: `${oldPlatform}/approval/instance/infoByNo`,
    data: params
  })
}